<div class="eos-table-total-pinned-row-renderer-container">
  <strong>{{params["value"] | currency}}</strong>
</div>
